import * as React from "react";
import { MouseEventHandler } from "react";
import styled from "styled-components";
import greenNoise from "../assets/images/green_noise.jpg";
import { TABLET } from "../constant/Breakpoints";

const Container = styled.header`
  background: url("${greenNoise}");
  display: flex;
  padding: 24px 48px;
  justify-content: center;

  > * {
    flex: 1;
  }

  @media screen and (max-width: ${TABLET}px) {
    display: none;
  }
`;

const Content = styled.div`
  max-width: 1280px;
  color: "white";
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (max-width: ${TABLET}px) {
    display: none;
  }
`;

const UL = styled.ul`
  list-style: none;
  display: flex;

  > li {
    font-family: Ubuntu;
    font-weight: 500;
    font-size: 22px;
    margin: 0 32px;
    cursor: pointer;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 108%;
      width: 0%;
      height: 3px;
      transition: all 300ms ease;
      background-color: white;
      opacity: 0;
    }

    &:hover::after {
      width: 90%;
      opacity: 1;
    }
  }
`;

const Link = styled.a`
  color: white;
  text-decoration: none;
`;

interface Props {
  logo: React.ReactElement;
  sections: Array<{
    title: string;
    dom: string;
  }>;
}

export const Header = ({ logo, sections }: Props) => (
  <Container>
    <Content>
      {logo}
      <UL>
        {sections.map(section => {
          const handleClick: MouseEventHandler = e => {
            try {
              const element = document.getElementById(section.dom);
              if (element) {
                const rect = element.getBoundingClientRect();
                window.scrollTo({
                  top: rect.top,
                  behavior: "smooth",
                });
                e.preventDefault();
              }
            } catch (e) {
              global.console.error(e);
            }
          };

          return (
            <li key={`${section.title}_${section.dom}`} onClick={handleClick}>
              <Link href={`#${section.dom}`}>{section.title}</Link>
            </li>
          );
        })}
      </UL>
    </Content>
  </Container>
);
